import useResizeObserver from "@react-hook/resize-observer";
import { useState, useLayoutEffect } from "react";
import React from "react";

import { useDebounce } from "./useDebounce";
import type { DebounceSettings } from "./useDebounce";

// only use this for size not position
export function useElementRect<T extends HTMLElement>(
  target: React.RefObject<T> | T | null,
  wait?: number,
  options?: DebounceSettings,
) {
  const [size, setSize] = useState<DOMRect>();
  const setSizeDebounced = useDebounce(setSize, wait ?? 0, options);

  useLayoutEffect(() => {
    const element = target && "current" in target ? target.current : target;

    if (!element) {
      return;
    }

    setSize(element.getBoundingClientRect());
  }, [target]);

  // Where the magic happens
  useResizeObserver(
    target,
    (entry) => setSizeDebounced && setSizeDebounced(entry.contentRect),
  );
  return size;
}
